<template>
  <footer
    class="footer footer--3"
    :class="{'footer--leaf': !isPortalTypeBooks && !isPortalTypeLoading}"
  >
    <div class="container">
      <div class="section-wrapper">
        <logo></logo>
        <div class="footer__main row">
            <div class="col-lg-6">
              <footer-nav></footer-nav>
            </div>
            <div class="col-lg-6">
              <contacts></contacts>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="col-lg-6">
            <copyright></copyright>
          </div>
          <div class="ml-auto col-lg-6">
            <paysistems></paysistems>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Logo from "./parts/Logo.vue";
import Slogan from "./parts/Slogan.vue";
import FooterNav from "./parts/FooterNav.vue";
import Contacts from "./parts/Contacts.vue";
import Paysistems from "./parts/Paysistems.vue";
import Copyright from "./parts/Copyright.vue";
import {useEnabledStore} from "@/stores/index.js";

export default {
  components: {
      Logo,
      Slogan,
      FooterNav,
      Contacts,
      Paysistems,
      Copyright,
  },
  data() {
    return {
      enabledStore: useEnabledStore()
    }
  },
  computed: {
    isPortalTypeBooks() {
      return this.enabledStore.isPortalTypeBooks
    },
    isPortalTypeLoading() {
      return this.enabledStore.isPortalTypeLoading;
    }
  },
};
</script>

<style
  lang="scss"
  scoped
>
$logo-width: 207px;

.footer--3 {
  .footer__logo {
      max-width: $logo-width;
      margin-bottom: 20px;
  }

  .footer__main {
    margin-bottom: 20px;
  }

  &.footer--leaf {
    .section-wrapper {
      min-height: 320px;
      margin: 20px 0;
      background-image: url(@/assets/images/leaf/footer-leaf.png);
      background-position: 30% bottom;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  @media (max-width: $breakpoint-lg) {
    &.footer--leaf {
      .section-wrapper {
        background-image: unset;
      }
    }

    .footer__main {
      gap: 40px;
    }
  }
}

.app-twa {
  .footer--3 {
    .section-wrapper {
      @media (max-width: $breakpoint-lg) {
        margin-bottom: 100px;
      }
    }
  }
}
</style>